import { connect } from "react-redux";
import PropTypes from "prop-types";

// Components
import BaseInputComponent from "basecomponents/BaseInputComponent";
import { InputField } from "../components/form";
import { Button } from "../components/button";
import Table from "../components/table";
import PaginationBar from "../components/paginationBar";

// Modals
import AdminAddClientModal from "modals/AdminAddClientModal";
import AdminEditClientModal from "modals/AdminEditClientModal";

// Interfaces
import { IClient } from "../interfaces/IClient";

// Actions
import {
  getAllClients,
  setClientEditFromFunction,
  deleteClient,
} from "../actions/clientActions";

// Utils
import { showModal, showPopUpConfirmation } from "../utils/domUtils";
class AdminDClients extends BaseInputComponent {
  state = {
    field: "",
  };

  idmodal_add_client = "modal_add_client";
  idmodal_edit_client = "modal_edit_client";

  componentDidMount() {
    this.searchConfig.getResultsFunctionName = "getAllClients";
    this.searchConfig.propsObjectName = "client";
    this.getResultsForComponent({
      from: 0,
    });
  }

  onTablePageClick = (newPage) => {
    this.getResultsForComponent({ currentPage: newPage });
  };

  onKeyUpField = () => {
    this.handleSearchField(this.state.field);
  };

  isLoading(): boolean {
    // @ts-ignore
    return this.props.client.loading;
  }

  getComponentResults(): Array<IClient> {
    // @ts-ignore
    const results: Array<IClient> = this.props.client.elements;
    return results;
  }

  onAddClientClick = () => {
    showModal(this.idmodal_add_client);
  };

  onEditClientClick = (client: IClient) => {
    // @ts-ignore
    this.props.setClientEditFromFunction(client);
    showModal(this.idmodal_edit_client);
  };

  onDeleteClientClick = (client: IClient) => {
    showPopUpConfirmation(
      `Realmente desea elminar al cliente "${client.name} ${client.code}"?`,
      "Esta accion removera al cliente y no podra ser utilizado nuevamente, los paquetes y articulos del cliente pasaran a estar sin propietario",
      (confirmation) => {
        if (!confirmation) return;
        this.onConfirmDeleteClient(client);
      }
    );
  };

  onConfirmDeleteClient = (client: IClient) => {
    // @ts-ignore
    this.props.deleteClient(client.id);
  };

  getInputSearch = () => {
    const { field } = this.state;
    return (
      <div className="input-search mb-2">
        <InputField
          id="field"
          name="field"
          placeholder="Buscar..."
          value={field}
          onChange={this.onChangeTextInput}
          onKeyUp={this.onKeyUpField}
        />
      </div>
    );
  };

  getResultsTable = () => {
    return (
      <>
        <Table
          isLoading={this.isLoading()}
          results={this.getComponentResults()}
          headers={[
            "",
            "ID",
            "Nombre",
            "Codigo",
            "Correo",
            "Telefono",
            "Activo",
            "Verificado",
            "Fecha de creaci&oacute;n",
          ]}
          getRowFN={this.getResultsTableRow}
        />
        <PaginationBar
          pagination={
            // @ts-ignore
            this.props.client.pagination
          }
          onPageClick={this.onTablePageClick}
        />
      </>
    );
  };

  getResultsTableRow = (client: IClient, uuid_key) => {
    return (
      <tr key={uuid_key}>
        <td>
          <div className="dropdown">
            <button
              className="btn btn-link"
              type="button"
              id={`dropdown_${client.id}`}
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="feather icon-more-vertical-"></i>
            </button>
            <div
              className="dropdown-menu"
              aria-labelledby={`dropdown_${client.id}`}
            >
              <a
                className="dropdown-item"
                href="#!"
                onClick={this.onEditClientClick.bind(this, client)}
              >
                <i className="feather icon-edit-2 mr-2"></i>Editar
              </a>
              <a
                className="dropdown-item"
                href="#!"
                onClick={this.onDeleteClientClick.bind(this, client)}
              >
                <i className="feather icon-trash mr-2"></i>Eliminar
              </a>
            </div>
          </div>
        </td>
        <td>{client.id}</td>
        <td>{client.name}</td>
        <td>{client.code}</td>
        <td>{client.email}</td>
        <td>{client.phone || ""}</td>
        <td>{client.is_active ? "Si" : "No"}</td>
        <td>{client.is_verified ? "Si" : "No"}</td>
        <td>{client.created_date}</td>
      </tr>
    );
  };

  render() {
    return (
      <>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <div className="card-title">
                  <span>Listado de clientes</span>
                  <Button
                    icon="icon-plus"
                    extraClass="btn-primary pull-right"
                    onClick={this.onAddClientClick}
                  />
                </div>
                <div className="card-body">
                  {this.getInputSearch()}
                  {this.getResultsTable()}
                </div>
              </div>
            </div>
          </div>
        </div>

        <AdminAddClientModal />
        <AdminEditClientModal />
      </>
    );
  }
}

// @ts-ignore
AdminDClients.propTypes = {
  client: PropTypes.object.isRequired,
  getAllClients: PropTypes.func.isRequired,
  setClientEditFromFunction: PropTypes.func.isRequired,
  deleteClient: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  client: state.client,
});

export default connect(mapStateToProps, {
  getAllClients,
  setClientEditFromFunction,
  deleteClient,
})(AdminDClients);
